import React from "react";
import { Page, Text, View, Document, StyleSheet } from "@react-pdf/renderer";
import numeral from "numeral";

const styles = StyleSheet.create({
  body: {
    paddingTop: 40,
    paddingBottom: 40,
    paddingLeft: 30,
    paddingRight: 20
  },
  title: {
    marginBottom: 3,
    fontSize: 18,
    textAlign: "justify",
    fontFamily: "Times-Roman",
  },
  text: {
    margin: 1,
    fontSize: 10,
    textAlign: "justify",
    fontFamily: "Times-Roman",
  },
  image: {
    marginVertical: 15,
    marginHorizontal: 100,
  },
  pageNumber: {
    position: "absolute",
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: "center",
    color: "grey",
  },
  //TABLE-----------------------
   table: {
    width: '100%',
    top: 15,
    paddingBottom: 40
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
  },
  borderBottom: {
    borderBottom: '1 solid #0000'
  },
  bold: {
    fontWeight: 'bold',
  },
  rowText: {
    fontSize: 10,
    fontFamily: "Times-Roman",
    fontWeight: 'bold',
  },
  alignLeft: {
    textAlign: 'left'
  },
  alignCenter: {
    textAlaign: 'center'
  },
  alignRight: {
    textAlign: 'right'
  },
  paddingNotes: {
    paddingBottom: 40
  },
  // So Declarative and unDRY 👌
  row1: {
    width: '5%',
  },
  row2: {
    width: '31%',
  },
  row3: {
    width: '8%',
  },
  row4: {
    width: '8%',
  },
  row5: {
    width: '8%',
  },
  row6: {
    width: '8%',
  },
  row7: {
    width: '11%',
  },
  row8: {
    width: '8%',
  },
  row9: {
    width: '8%',
  },
  row10: {
    width: '10%',
  },
});



const PDFExpenseHistory = ({ data, grandTotal, dateFrom, dateTo, account }) => {

  return (
    <Document>
      <Page orientation="landscape" style={styles.body}>
        {/* <Text style={styles.header} fixed>qweqwe</Text> */}
        <Text style={styles.title}>
          Expense Report {'('+account.description+'-'+account.branchidno+')'}
        </Text>
        <Text style={styles.text}>
          Date From: {dateFrom}
        </Text>
        <Text style={styles.text}>
          Date To: {dateTo}
        </Text>
        
        {/* TABLE */}
        <View style={styles.table}>
          <View style={[styles.row, styles.rowText, styles.borderBottom]}>
            <Text style={[styles.row2, styles.rowText, styles.alignLeft]}>Pay To</Text>
            <Text style={[styles.row3, styles.rowText, styles.alignCenter]}>Exp No.</Text>
            <Text style={[styles.row4, styles.rowText, styles.alignLeft]}>Reference</Text>
            <Text style={[styles.row5, styles.rowText, styles.alignLeft]}>Trandate</Text>
            <Text style={[styles.row6, styles.rowText, styles.alignLeft]}>Account ID</Text>
            <Text style={[styles.row7, styles.rowText, styles.alignLeft]}>Description</Text>
            <Text style={[styles.row8, styles.rowText, styles.alignLeft]}>Branch ID</Text>
            <Text style={[styles.row9, styles.rowText, styles.alignLeft]}>IS CV</Text>
            <Text style={[styles.row10, styles.rowText, styles.alignRight]}>Total Amount</Text>
          </View>
          {data ? data.map((row, i) => (
            <View key={i} style={styles.row} wrap={false}>
              <Text style={[styles.row2, styles.rowText, styles.alignLeft]}>{row.payto}</Text>
              <Text style={[styles.row3, styles.rowText, styles.alignCenter]}>{row.expno}</Text>
              <Text style={[styles.row4, styles.rowText, styles.alignLeft]}>{row.refno}</Text>
              <Text style={[styles.row5, styles.rowText, styles.alignLeft]}>{row.trandate}</Text>
              <Text style={[styles.row6, styles.rowText, styles.alignLeft]}>{row.acctid}</Text>
              <Text style={[styles.row7, styles.rowText, styles.alignLeft]}>{row.description}</Text>
              <Text style={[styles.row8, styles.rowText, styles.alignLeft]}>{row.branchidno}</Text>
              <Text style={[styles.row9, styles.rowText, styles.alignLeft]}>{row.iscv}</Text>
              <Text style={[styles.row10, styles.rowText, styles.alignRight]}>{numeral(row.tamount).format('00,0.00')}</Text>
            </View>
          )) : ''}
      </View>

      {/* TOTALITIES */}
      <Text style={[styles.text,styles.alignRight]}>
          Total: {grandTotal}
      </Text>

      {/* NOTES */}
      {/* <Text style={[styles.text,styles.alignLeft]}>
          **Notes**:
      </Text>
      <Text style={[styles.text,styles.alignLeft,styles.paddingNotes]}>
        {notes}
      </Text> */}

      {/* Encoded */}
      {/* <Text style={[styles.text,styles.alignLeft]}>
          |Encoded By: {encoder}
      </Text>
      <Text style={[styles.text,styles.alignLeft]}>
          |Approved By: {approver}
      </Text> */}


        <Text 
          style={styles.pageNumber}
          render={({ pageNumber, totalPages }) => (
          `${pageNumber} / ${totalPages}`
        )} fixed />
      </Page>
    </Document>
  );
};

export default PDFExpenseHistory;